import React from 'react';

import DotPoints from '../../presentational/DotPoints';
import oneDayLogo from '../../../images/phyto/one-day-herbs.jpg';
import hapLogo from '../../../images/hap-logo.jpg';
import data from '../../../core/data';

import bPeelB from "../../../images/phyto/bpeel-alt-b.png";

const points = data.phyto.poster.points;

const BPeelPoster = (props) => {
  return (
    <section id="bpeel-poster">
      <div className="leaf-backdrop-1 hidden-md hidden-sm hidden-xs" />
      <div className="leaf-backdrop-2 hidden-md hidden-sm hidden-xs" />
      <div className="container">
        <div className="body">
          <div className="background"></div>
          <h1>Beauty Peel</h1>
          <h2>Visibly Beautiful Skin</h2>
          <img src={ bPeelB } />
        </div>
        <div className="row">
          <div className="col-md-3 logo hidden-sm hidden-xs"><img src={ oneDayLogo } /></div>
          <div className="col-md-6 dot-points">
            <DotPoints array={ points } />
          </div>
          <div className="col-md-3 logo hidden-sm hidden-xs"><img src={ hapLogo } /></div>
        </div>
      </div>
    </section>
  )
}

export default BPeelPoster;



/** WEBPACK FOOTER **
 ** ./src/components/containers/bpeel/BPeelPoster.jsx
 **/